import {
  getSessionStorage,
  removeSessionStorage,
  setSessionStorage,
} from './dataStorage';

export const StorageKeys = {
  IS_PROCESSING_DEEPLINK: 'isProcessingDeeplink',
  POST_LOGIN_DEEPLINK: 'postLoginDeeplink',
} as const;

export const deeplinkStorage = {
  setProcessing: () => setSessionStorage(StorageKeys.IS_PROCESSING_DEEPLINK, 'true'),
  clearProcessing: () => removeSessionStorage(StorageKeys.IS_PROCESSING_DEEPLINK),
  isProcessing: () => getSessionStorage(StorageKeys.IS_PROCESSING_DEEPLINK) === 'true',

  setPostLoginRedirect: (url: string) =>
    setSessionStorage(StorageKeys.POST_LOGIN_DEEPLINK, url),
  getPostLoginRedirect: () => getSessionStorage(StorageKeys.POST_LOGIN_DEEPLINK),
  clearPostLoginRedirect: () => removeSessionStorage(StorageKeys.POST_LOGIN_DEEPLINK),
};

export const consumePostLoginDeeplink = (clearPageState: () => void): string | null => {
  const url = deeplinkStorage.getPostLoginRedirect();
  if (url) {
    deeplinkStorage.clearPostLoginRedirect();
    clearPageState();
  }
  return url;
};
